/* eslint-disable no-dupe-keys */
import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    flexContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      gap: '0px',
      maxWidth: '100%',
      overflow: 'hidden',
      paddingLeft: 0,
    },
    grab: {
      cursor: 'move',
      flexShrink: 0,
      padding: 0,
      minWidth: '32px',
      width: '32px',
      height: '32px',
      margin: 0,
      marginRight: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
    },
    modalContent: {
      fontSize: 14,
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
    modalText: {
      fontSize: 14,
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
  })
);

export default useStyles;
